import axios from "axios";
import { LOGIN_URL, ME_URL, USER_URL, FORGOT_PASSWORD_URL } from "./api";
import { authorizationHelper } from "../common/helpers";

export function login(username, password, web_guid) {
    const data = {
        email: username,
        password
    };

    const params = {
        guid: web_guid
    };

    return axios.post(LOGIN_URL, data, {
        params
    });
}

export function getActualUser() {
    return axios.get(ME_URL, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function requestForgotPassword(email) {
    const data = { email };

    return axios.post(FORGOT_PASSWORD_URL, data, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function resetPassword(token, password, confirmPassword) {
    const data = { token, password, confirmPassword };

    return axios.put(FORGOT_PASSWORD_URL, data, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function getAll(page, filter, storeId, option) {
    const params = {
        page,
        filter,
        store_id: storeId,
        option
    };

    return axios.get(USER_URL, {
        params,
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function get(id) {
    const url = `${USER_URL}/${id}`;

    return axios.get(url, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function create(user) {
    return axios.post(USER_URL, user, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function uploadPhoto(id, photo) {
    let data = new FormData();
    data.append("photo", photo);

    const url = `${USER_URL}/${id}/photo`;

    return axios.put(url, data, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function deletePhoto(id) {
    const url = `${USER_URL}/${id}/photo`;

    return axios.delete(url, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function update(id, user) {
    const url = `${USER_URL}/${id}`;

    return axios.put(url, user, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}

export function deleteUser(id) {
    const url = `${USER_URL}/${id}`;

    return axios.delete(url, {
        headers: { Authorization: authorizationHelper.getAuthorizationToken() }
    });
}



// WEBPACK FOOTER //
// ./src/service/user.js